<ng-container *transloco="let t; prefix: 'customers.customersDetail'">
  <div class="select-destination-heading">
    <span class="title-large-emphasized">{{ t('delivery.destinations.title') }}</span>
  </div>

  <mat-form-field appearance="outline" class="destination-search" subscriptSizing="dynamic">
    <input matInput type="text" [placeholder]="'orders.ui.cercaDestino' | transloco" [formControl]="searchControl">
  </mat-form-field>

  @for (destination of filteredDestinations(); track destination.id) {
    <div
      class="delivery-destination-card"
      [class.delivery-destination-card--selected]="selectedId() === destination.id"
      (click)="onSelectDestination(destination)"
    >
      <div class="delivery-destination-card-content">
        <div class="delivery-destination-card-header">
          <div class="delivery-destination-card-header-item">
            <div class="delivery-destination-card-header-item-content">
              <span class="body-small">{{ destination.riferimento || '-' }}</span>
              <span class="body-medium-emphasized">
                {{ destination.citta || '-' }}@if (destination.provincia) { ({{ destination.provincia }}) }
              </span>
              @if (destination.principale) {
                <div class="delivery-destination-card-header-item-default">
                  <i class="fa-solid fa-star"></i>
                  <span class="body-small">{{ t('delivery.destinations.defaultDestination') }}</span>
                </div>
              }
            </div>
          </div>
          <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.dettagliIndirizzo' | transloco" (click)="openDetails($event, destination)">
            <i class="fa-regular fa-circle-info"></i>
          </button>
        </div>
        <div class="delivery-destination-card-divider"></div>
        <div class="delivery-destination-card-details">
          <div class="delivery-destination-card-generalities">
            <div class="delivery-destination-card-generalities-content">
              @for (field of generalitiesFields; track field.key) {
                <div class="delivery-destination-card-generalities-field">
                  <span class="body-small">{{ t(field.labelKey) }}</span>
                  <span class="body-medium-emphasized">{{ getGeneralityValue(destination, field.key) }}</span>
                </div>
              }
            </div>
          </div>
          <div class="delivery-destination-card-notes">
            <span class="body-medium-emphasized">{{ t('tabs.notes') }}</span>
            <div class="delivery-destination-card-notes-content">
              @for (field of notesFields; track field.key) {
                <div class="delivery-destination-card-notes-field">
                  <span class="body-small">{{ t(field.labelKey) }}</span>
                  @if (field.key === 'sponda') {
                    <span class="body-medium-emphasized">
                      {{ destination.nota.sponda === true ? t('common.yes') : t('common.no') }}
                    </span>
                  } @else {
                    <span class="body-medium-emphasized">{{ destination.nota[field.key] || '-' }}</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="delivery-destination-card-divider"></div>
        <div class="delivery-destination-card-footer">
          <mat-checkbox
            class="delivery-destination-card-footer-checkbox"
            [checked]="destination.nota.inBolla"
            tabindex="-1"
          >
            {{ t('delivery.destinations.addToDeliveryNote') }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  } @empty {
    <div class="destinations-empty">
      <span class="body-medium">{{ 'orders.ui.nessunElementoTrovato' | transloco }}</span>
    </div>
  }

  <div class="buttons-container">
    <button matButton type="button" (click)="cancel()">{{ 'orders.ui.annulla' | transloco }}</button>
    <button matButton="filled" type="button" [disabled]="!selectedId()" (click)="confirm()">{{ 'orders.ui.conferma' | transloco }}</button>
  </div>
</ng-container>
